// extracted by mini-css-extract-plugin
export default {"counterHeader":"Repos_counterHeader__py7Cs","reposContainer":"Repos_reposContainer__R7IUU","btn":"Repos_btn__05nVO","icon":"Repos_icon__7585x"};